import parse from "html-react-parser";
import React, { useEffect, useRef, useState } from "react";
import { search as searchIcon } from "../../assets/images/icons";
import "./searchInput.scss";

import { navigate } from "gatsby";
import { updateParentUrl } from "../../bridges/BridgeMethods/InitializeWeb";
import {
  ingestData,
  isMobile,
} from "../../bridges/BridgeServices";
import {
  EVENTS,
  TEMPLATES_URI,
} from "../../utils/constants";
import {
  appendSearchParamsToURL,
  isShowWebHeader,
} from "../../utils/helperFunctions";
import SearchResults from "../SearchResults/searchResults";

const SearchInput = ({
  type,
  name,
  placeholder = "Looking for something specific?",
  data,
  inputData = "",
  ...inputProps
}) => {
  const [isBlur, setIsBlur] = useState(false);
  const [input, setInput] = useState("");
  const [isInputFocus, setIsInputFocus] = useState(false);

  const ref = useRef(null);

  useEffect(() => {
    setInput(inputData);
    setIsBlur(true);
  }, [inputData]);

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        ref.current &&
        !ref.current.contains(event.target)
      ) {
        setIsBlur(true);
      }
    };
    document.addEventListener(
      "click",
      handleClickOutside,
      true
    );
    return () => {
      document.removeEventListener(
        "click",
        handleClickOutside,
        true
      );
    };
  }, []);

  const redirectToSearchPage = (key = "", value = "") => {
    const searchParam = appendSearchParamsToURL(key, value);
    navigate(`${TEMPLATES_URI.SEARCH}?${searchParam}`);
  };
  const handleInputChange = e => {
    const searchValue = e?.target?.value;
    if (
      searchValue.length > 0 &&
      isMobile() &&
      !isShowWebHeader()
    ) {
      redirectToSearchPage("q", searchValue);
    }
    setInput(searchValue);
    setIsBlur(false);
  };

  const handleOnClick = () => {
    if (!isMobile()) {
      return;
    }
    setIsInputFocus(true);
    redirectToSearchPage();
    ingestData({
      name: EVENTS.FAQ_SEARCH_CLICKED,
      data: {
        search: input,
      },
    });
  };

  const handleBlur = () => {
    setIsInputFocus(false);
  };

  const handleKeyPress = event => {
    if (event.key === "Enter" && input.length >= 3) {
      updateParentUrl({
        url: TEMPLATES_URI.SEARCH,
        queryParam: [{ key: "q", value: input }],
      });
      redirectToSearchPage("q", input);
    }
  };

  if (isMobile() && isShowWebHeader()) {
    return (
      <div
        onClick={handleOnClick}
        className="search-input-wrapper"
      >
        {parse(searchIcon)}
      </div>
    );
  }

  return (
    <>
      <div
        ref={ref}
        className={`search-container
         ${
           isMobile() && isInputFocus
             ? "mobile-container-focused"
             : ""
         } async-search ${
          input?.length > 0
            ? "async-search-with-results"
            : ""
        }`}
      >
        {parse(searchIcon)}
        <input
          className={"input"}
          id={name}
          type={type}
          value={input}
          onChange={handleInputChange}
          placeholder={placeholder}
          data-testid={"search-input"}
          onKeyDown={handleKeyPress}
          onBlur={handleBlur}
          {...inputProps}
        />
      </div>

      {!isBlur && (
        <SearchResults data={data} input={input} />
      )}
    </>
  );
};

export default SearchInput;
